import { MainProductData } from '../../../Bundles/types';
import { StyledMainProduct } from './style';

export const ProductMadnessSpecialOfferMainProduct: React.FC<
  Pick<MainProductData, 'quantityDisplay' | 'images'>
> = ({ quantityDisplay, images = { product: '' } }) => {
  return (
    <StyledMainProduct gap={'4px'}>
      <h2 className="quantity">{quantityDisplay}</h2>
      <img src={images.product} alt="main product" />
    </StyledMainProduct>
  );
};
